import { Component, Prop, Vue } from 'vue-property-decorator'
import { Filter } from '@/interfaces/filter'

@Component
export class FilterComponentMixin extends Vue {
  @Prop(Object)
  readonly filter!: Filter
}
